import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExtensionOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"extension_off"}/>
}
